export default "__VITE_ASSET__CWSa$ObE__"